import Vue from 'vue';
import Vuex from 'vuex';

import user from '@/_store/modules/user'
import cookiePolicy from '@/_store/modules/cookiePolicy'
import authController from '@/_store/modules/authController'
import popup from '@/_store/modules/popup'
import agenda from '@/_store/modules/agenda'
import video from '@/_store/modules/video'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    api: {
      auth: 'https://api.reydar.com/api/Ultimaker/',
      dataURL: 'https://api.reydar.com/api/VirtualEvent/',
    },
  },
  mutations: {

  },
  actions: {

  },
  modules: {
    user,
    cookiePolicy,
    authController,
    popup,
    agenda,
    video
  },
});
